var popup_nl = popup_nl || {};

popup_nl.PopupNewsletter = (function() {

   function PopupNewsletter() {
      this.$subscribe = $( '#popup_nl-sub' );
      this.$coupon = $( '#popup_nl-coupon' );
      this.$popup = null;
   }

   PopupNewsletter.prototype = _.extend( PopupNewsletter.prototype, {
      open: function( type, callbacks ) {

         if ( this.$popup ) {
            this.$popup.close();
         }

         var callbacks = callbacks || null;

         var _$src = null;
         switch ( type ) {
            case 'subscribe_popup':
               _$src = this.$subscribe;
               break;

            case 'coupon_popup':
               _$src = this.$coupon;
               break;

            default:
               throw 'Illegal popup type passed to PopupNewsletter#open';
         }

         $.magnificPopup.open( {
            items: {
               src: _$src,
               type: 'inline'
            },
            midClick: true,
            closeBtnInside: true,
            mainClass: 'mfp-fade',
            callbacks: callbacks
         });

         this.$popup = $.magnificPopup.instance;
      },

      close: function() {
         if ( this.$popup ) {
            this.$popup.close();
            this.$popup = null;
         }
      },

      isOpen: function() {
         return this.$popup !== null;
      },

      destroy: function() {
         this.close();
      }
   });

   return PopupNewsletter;

})();
